import actionsTypes from './actionTypes';
import {
  IFetchActiveSkillsResponsePayload,
  IFetchDeniedSkillsResponsePayload,
  IFetchPendingSkillsResponsePayload,
  ILoadDataRequestPayload,
  IProcessRequestPayload,
} from './types';
import {
  LoadActiveSkillsErrorAction,
  LoadActiveSkillsRequestAction,
  LoadActiveSkillsSuccessAction,
  LoadDeniedSkillsErrorAction,
  LoadDeniedSkillsRequestAction,
  LoadDeniedSkillsSuccessAction,
  LoadPendingSkillsErrorAction,
  LoadPendingSkillsRequestAction,
  LoadPendingSkillsSuccessAction,
  ProcessActionErrorAction,
  ProcessActionRequestAction,
  ProcessActionSuccessAction,
} from './actions.d';

const actions = {
  processActionRequest: <T1, T2>(payload: IProcessRequestPayload<T1, T2>): ProcessActionRequestAction<T1, T2> => ({
    type: actionsTypes.PROCESS_ACTION_REQUEST,
    payload,
  }),

  processActionSuccess: (): ProcessActionSuccessAction => ({
    type: actionsTypes.PROCESS_ACTION_SUCCESS,
  }),

  processActionError: (): ProcessActionErrorAction => ({
    type: actionsTypes.PROCESS_ACTION_ERROR,
  }),

  loadActiveSkillsRequest: <T1, T2>(
    payload: ILoadDataRequestPayload<T1, T2>,
  ): LoadActiveSkillsRequestAction<T1, T2> => ({
    type: actionsTypes.LOAD_ACTIVE_SKILL_REQUEST,
    payload,
  }),

  loadActiveSkillsSuccess: (payload: IFetchActiveSkillsResponsePayload): LoadActiveSkillsSuccessAction => ({
    type: actionsTypes.LOAD_ACTIVE_SKILL_SUCCESS,
    payload,
  }),

  loadActiveSkillsError: (): LoadActiveSkillsErrorAction => ({
    type: actionsTypes.LOAD_ACTIVE_SKILL_ERROR,
  }),

  loadPendingSkillsRequest: <T1, T2>(
    payload: ILoadDataRequestPayload<T1, T2>,
  ): LoadPendingSkillsRequestAction<T1, T2> => ({
    type: actionsTypes.LOAD_PENDING_SKILL_REQUEST,
    payload,
  }),

  loadPendingSkillsSuccess: (payload: IFetchPendingSkillsResponsePayload): LoadPendingSkillsSuccessAction => ({
    type: actionsTypes.LOAD_PENDING_SKILL_SUCCESS,
    payload,
  }),

  loadPendingSkillsError: (): LoadPendingSkillsErrorAction => ({
    type: actionsTypes.LOAD_PENDING_SKILL_ERROR,
  }),

  loadDeniedSkillsRequest: <T1, T2>(
    payload: ILoadDataRequestPayload<T1, T2>,
  ): LoadDeniedSkillsRequestAction<T1, T2> => ({
    type: actionsTypes.LOAD_DENIED_SKILL_REQUEST,
    payload,
  }),

  loadDeniedSkillsSuccess: (payload: IFetchDeniedSkillsResponsePayload): LoadDeniedSkillsSuccessAction => ({
    type: actionsTypes.LOAD_DENIED_SKILL_SUCCESS,
    payload,
  }),

  loadDeniedSkillsError: (): LoadDeniedSkillsErrorAction => ({
    type: actionsTypes.LOAD_DENIED_SKILL_ERROR,
  }),
};

export default actions;
